export default "/images/divny-dom.png?65a8404232bc5b93a287545949bed703";